export default Object.freeze({
  Assistance: 1,
  Specialist: 2,
  Master: 3,
})
